module.exports = __webpack_public_path__ + "media/images/games/35reveal/skyline-8a598d63f69fb425d23d4eaa23f33990.png";